"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessContext = exports.AccessProvider = void 0;
const react_1 = __importDefault(require("react"));
const AccessContext = react_1.default.createContext({
    permissions: [],
    setPermissions: () => [],
    has: () => false,
    loaded: false,
    user: undefined,
    userId: undefined,
    setLoaded: () => { },
    setUserId: () => { },
    setUserAndPermissions: () => { },
    setUser: () => { },
});
exports.AccessContext = AccessContext;
const AccessProvider = (props) => {
    // the state
    const [user, setUser] = react_1.default.useState();
    const [loaded, setLoaded] = react_1.default.useState(false);
    const has = (permissionType) => { var _a; return ((_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a.includes(permissionType)) || false; };
    const setPermissions = (permissions) => setUser((u) => (Object.assign(Object.assign({}, u), { permissions })));
    const setUserId = (userId) => setUser((u) => (Object.assign(Object.assign({}, u), { userId })));
    const populateUser = (newUser) => {
        setUser((u) => (Object.assign(Object.assign({}, u), newUser)));
        setLoaded(true);
    };
    // cache the context value
    const value = react_1.default.useMemo(() => ({
        loaded,
        user,
        userId: user === null || user === void 0 ? void 0 : user.id,
        permissions: (user === null || user === void 0 ? void 0 : user.permissions) || [],
        has,
        setLoaded,
        setUserId,
        setPermissions,
        setUserAndPermissions: populateUser,
        setUser: populateUser,
    }), [user, loaded]);
    return (react_1.default.createElement(AccessContext.Provider, { value: value }, props.children));
};
exports.AccessProvider = AccessProvider;
